import Vue from 'vue';
import Vuex from 'vuex';

import entry from './modules/entry';
import preloader from './modules/preloader';

Vue.use( Vuex );
require( 'es6-promise' ).polyfill();

export default new Vuex.Store({
    strict: true,

    modules: {
        entry,
        preloader
    },

    state: {

    },

    getters: {

    },

    mutations: {

    },

    actions: {

    }
});
